import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.scss";
import logo from "../../../assets/images/logo-footer.png";
import img from "../../../assets/images/face.png";

import img2 from "../../../assets/images/insta.png";
import img3 from "../../../assets/images/linke.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import log from "../../../assets/images/log.png";
export default function Footer() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <footer className="footer-section">
      <Container>
        {/* Titre */}
        <h2 className="footer-title d-none d-md-block">
          {t("footer.title")}
          <br /> {t("footer.title2")}
        </h2>
        <div className="d-flex justify-content-between align-items-center">
          {" "}
          <h2 className="footer-title d-block d-md-none">
            {t("footer.title")}
            <br /> {t("footer.title2")}
          </h2>{" "}
          <img src={log} className="d-block d-md-none me-3" />
        </div>
        {/* Bouton */}
        <Button
          className="contact-btn"
          onClick={() => {
            navigate("/contact");
            window.scrollTo(0, 0);
          }}>
          {t("footer.contactButton")}
        </Button>

        {/* Infos de contact */}
        <Row className="contact-info">
          <Col md={4} className="text-md-start text-center mb-3 mb-md-0">
            <img
              src={logo}
              alt={t("footer.logoAlt")}
              className="footer-logo d-md-block d-none"
            />
          </Col>
          <Col md={4} className="text-md-center text-start">
            <p className="mb-1">{t("footer.email")}</p>
            <p>{t("footer.phone")}</p>
          </Col>
          <Col
            md={4}
            className="text-md-start text-start d-flex justify-content-md-end justify-content-md-start ">
            <p className="adrees-text">
              {t("footer.addressLine1")} <br />
              {t("footer.addressLine2")} <br />
              {t("footer.addressLine3")} <br />
              {t("footer.addressLine4")}
            </p>
          </Col>
          <div className="d-flex gap-3">
            <a
              href="https://www.facebook.com/MSITConseil"
              className="d-md-none d-block">
              <img src={img} />
            </a>
            <a
              href="https://tn.linkedin.com/company/msit-conseil"
              className="d-md-none d-block">
              <img src={img3} />
            </a>
            <a
              href="https://www.instagram.com/msit.conseil/"
              className="d-md-none d-block">
              <img src={img2} />
            </a>
          </div>
        </Row>
      </Container>

      <hr className="divider" />
      <Container className="text-center">
        {/* Bas du footer */}
        <Row className="footer-bottom align-items-center">
          <Col md={4} className="text-start">
            <p className="copyright">{t("footer.copyright")}</p>
          </Col>
          <Col md={4} className="text-center social-icons">
            <a
              href="https://www.facebook.com/MSITConseil"
              className="d-none d-md-block">
              <img src={img} />
            </a>
            <a
              href="https://tn.linkedin.com/company/msit-conseil"
              className="d-none d-md-block">
              <img src={img3} />
            </a>
            <a
              href="https://www.instagram.com/msit.conseil/"
              className="d-none d-md-block">
              <img src={img2} />
            </a>
          </Col>
          <Col
            md={4}
            className="text-md-end text-start text-center footer-links">
            <a href="/mentions-legales">{t("footer.links.faq")}</a>
            <a href="/blogs">{t("footer.links.blogs")}</a>
            <a href="/contact">{t("footer.links.contact")}</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
